import { MainLayout } from "components/layouts/MainLayout";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from 'react';
const Live = React.lazy(() => import("../page"));

const routes: AppRouteType[] = [
  {
    path: slugs.live,
    component: Live,
    container: MainLayout,
    isAuthNeeded: true,
  },
];

export default routes;
